import React from 'react';
import { createRoot } from 'react-dom/client';
import { TaskPane } from './taskpane/TaskPane';

// Initialize Office.js before rendering
Office.onReady(() => {
  const container = document.getElementById('root');
  if (container) {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <TaskPane />
      </React.StrictMode>
    );
  }
});
